import { useFormikContext } from 'formik';
import { Input, FormItem } from 'formik-antd';

const FormInputPassword = ({
  label,
  name,
  value,
  type,
  onChange: onChangeParam,
  required,
  showSpinner,
  button,
  icon,
  iconColor,
  disabled,
  showValidateSuccess,
  autoFocus,
  placeholder,
  maxLength,
  ...rest
}) => {
  const { getFieldMeta } = useFormikContext();
  const { error, touched } = getFieldMeta(name);

  const onChange = newValue => {
    if (!disabled && onChangeParam) {
      onChangeParam(newValue);
    }
  };

  return (
    <FormItem
      name={name}
      required={required}
      showValidateSuccess={showValidateSuccess}>
      <span style={{ color: error && touched && '#ff4d4f' }}>
        {label && (required ? `${label} *` : label)}
      </span>
      <Input.Password
        value={value}
        onChange={e => onChange(e.target.value)}
        autoFocus={autoFocus}
        placeholder={!label ? placeholder : ''}
        maxLength={maxLength}
        name={name}
        required={required}
        {...rest}
      />
    </FormItem>
  );
};

export default FormInputPassword;
